<script setup lang="ts">
// The settings host frame (contract 22 §10) — replaces v3's `views/App/WorkspaceSettings.vue`,
// which mounted all eight panes eagerly behind `v-show` (~14.5k ln executed on open). Here the
// frame is a nested-route PARENT: one lazy chunk per pane, and a pane registered by 30/23/15/12/11
// nests in this very shell without either side importing the other (§11, §18 Q3).
//
// Title and optional description come from matched route meta; a child that declares its own
// keys overrides the host defaults through vue-router's matched-meta merge. This keeps the one
// production header in the host while registered panes remain lazy route children.
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useI18n } from '@/shared/i18n'
import { PageHeader } from '@/shared/ui/page-header'

const { t } = useI18n()
const route = useRoute()

const titleKey = computed(() => route.meta.titleKey ?? 'workspaceSettings.page.title')
const subtitleKey = computed(() => route.meta.subtitleKey)
const ownsHeader = computed(() => route.meta.ownsHeader === true)
const headerProps = computed<{ title: string; subtitle?: string }>(() => {
  const title = t(titleKey.value)
  return subtitleKey.value ? { title, subtitle: t(subtitleKey.value) } : { title }
})
</script>

<template>
  <section
    class="settings-layout grid content-start gap-xs min-h-[calc(100dvh_-_4.5rem_-_var(--ui-page-current-inset)_-_var(--ui-page-current-inset))] p-[var(--ui-page-surface-padding)] rounded-[var(--ui-page-surface-radius)] bg-surface shadow-[var(--ui-page-surface-shadow)]"
    data-testid="settings-layout"
  >
    <PageHeader v-if="!ownsHeader" v-bind="headerProps" />

    <RouterView />
  </section>
</template>
